import React, { createContext, useContext, ReactNode } from "react";
import {
    BootstrapConfig,
    RuntimeConfig,
    WorkbenchConfig,
} from "../types/Configs";

interface ConfigContextType {
    runtimeConfig: RuntimeConfig | null;
    workbenchConfig: WorkbenchConfig | null;
    bootstrapConfig: BootstrapConfig | null;
    isLoading: boolean;
}

const ConfigContext = createContext<ConfigContextType | null>(null);

export const useConfig = () => {
    const context = useContext(ConfigContext);
    if (!context) {
        throw new Error("useConfig must be used within ConfigProvider");
    }
    return context;
};

interface ConfigProviderProps {
    children: ReactNode;
    value: ConfigContextType;
}

export const ConfigProvider: React.FC<ConfigProviderProps> = ({
    children,
    value,
}) => {
    return (
        <ConfigContext.Provider value={value}>
            {children}
        </ConfigContext.Provider>
    );
};
